import isBrowser from '@util/isBrowser';

const APP_ROOT = isBrowser ? window.location.origin : '';

export const oidcSettings = {
  authority: process.env.SSO_URL,
  client_id: 'bmo-subscription-pkce',
  redirect_uri: `${APP_ROOT}/authredirect/`,
  silent_redirect_uri: `${APP_ROOT}/silentrenew/`,
  response_type: 'code',
  scope: 'openid profile bm-services offline_access federation',
  post_logout_redirect_uri: `${APP_ROOT}`,
  automaticSilentRenew: true,
  silentRequestTimeoutInSeconds: 10,
  filterProtocolClaims: true,
  loadUserInfo: false,
  //* must stay false: the check-session iframe is cross-site to the SSO domain, so
  //* browsers that block third-party cookies (Safari, Incognito) report a false
  //* "signed out" and would force-logout right after login. SSO logout elsewhere
  //* is detected via failing token renewal instead (see oidc-config.js).
  monitorSession: false,
};

// create-account endpoint returnUrl
export const returnUrl = `${APP_ROOT}/login/`;
